import React from "react";
import Select from "react-select";
import { useState } from "react";

const SimpleSelect = ({
  name,
  value,
  onChange,
  onBlur,
  // touched,
  options,
  isInvalid,
  error,
  isClearable
}) => {
    const handleChange = selectedOptions => {
        onChange(name, selectedOptions);
      };
    
      const handleBlur = () => {
        onBlur(name, true);
      };

  return (
    <>
    <Select
      options={options}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      isInvalid={isInvalid}
      isClearable={isClearable}
      placeholder="Select an attribute"
      error={error}
      />
      {isInvalid && (
        <div className="text-danger mt-1">
          {error}
        </div>
      )}
      </>

  );
};

export default SimpleSelect;
